import React from 'react';
import { ContributionItem } from 'services/requests';
import { useModalState } from 'hooks/modals';
import { UserIcon_16 } from 'assets/icons';
import AssignDepositModal from './AssignDepositModal';

import styles from './AssignDepositButton.module.css';

type AssignDepositButtonProps = {
  contributionItemInfo: ContributionItem;
};

const AssignDepositButton: React.FC<AssignDepositButtonProps> = ({
  contributionItemInfo,
}) => {
  const { closeModal, openModal, isModalVisible } = useModalState();

  const handleIconClick = () => {
    openModal();
  };

  return (
    <React.Fragment>
      <div onClick={(e: React.MouseEvent) => e.stopPropagation()}>
        <UserIcon_16 onClick={() => handleIconClick()} className={styles.userIcon} />
        {isModalVisible && (
          <AssignDepositModal
            onRequestClose={closeModal}
            isOpen={isModalVisible}
            contributionItemInfo={contributionItemInfo}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default AssignDepositButton;
